import { render, staticRenderFns } from "./ArtistInfo.vue?vue&type=template&id=91389e2e&scoped=true&"
import script from "./ArtistInfo.vue?vue&type=script&lang=js&"
export * from "./ArtistInfo.vue?vue&type=script&lang=js&"
import style0 from "./ArtistInfo.vue?vue&type=style&index=0&id=91389e2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91389e2e",
  null
  
)

export default component.exports